import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type DiscussionsButtonProps = ComponentProps<'button'>;

export const DiscussionsButton = memo(({ className, ...restOfProps }: DiscussionsButtonProps) => {
  return (
    <button
      className={cn('rounded-2 p-1 font-semibold text-12 text-gray-11 hover:bg-gray-5', className)}
      data-testid="DISCUSSIONS_BUTTON"
      {...restOfProps}
    />
  );
});

DiscussionsButton.displayName = 'DiscussionsButton';
